/* CUSTOM reveal — dezentes, editoriales Einblenden beim Scrollen.
   WICHTIG: Inhalte im ersten Viewport werden NIE versteckt (sie sind sofort sichtbar).
   Nur Sektionen UNTER dem Fold starten verdeckt und blenden beim Reinscrollen ein.
   Damit kein Konflikt mit den View-Transitions (Seitenwechsel-Crossfade) — sonst
   flackerte der Inhalt (rein → kurz weg → wieder rein). Respektiert reduced-motion. */
(function () {
  if (window.__reveal) return;
  window.__reveal = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return; // dann bleibt alles sofort sichtbar

  function targets() {
    return Array.prototype.slice.call(
      document.querySelectorAll('#MainContent > .shopify-section, main > .shopify-section')
    );
  }

  function init() {
    var els = targets();
    if (!els.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;

    // Phase 1: NUR Sektionen verdecken, die (nahezu) ganz unter dem Fold liegen (opacity 0).
    // Cutoff 0.95vh: alles, was beim Laden noch sichtbar reinschaut, bleibt sichtbar — sonst
    // verschwände eine peekende Section erst und fadete dann zurück (Flash). Above-the-fold
    // bleibt ohnehin sichtbar (kein Flackern beim View-Transition-Seitenwechsel).
    var hidden = [];
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top >= vh * 0.95) {
        el.classList.add('reveal');
        hidden.push(el);
      }
    });
    if (!hidden.length) return;

    // Phase 2: ERST den Opacity-0-Zustand zeichnen lassen (doppeltes rAF), DANN beobachten.
    // Sonst setzt der Observer bei Sektionen dicht am Fold im selben Frame `is-revealed`
    // BEVOR der 0-Zustand gemalt wurde → die Section snappt sichtbar rein statt zu faden.
    // threshold 0 = beim ersten Pixel im (um 10% verkürzten) Viewport auslösen — sonst
    // müsste bei hohen Sektionen erst % der Fläche rein, das Reveal käme spürbar zu spät.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('is-revealed');
              io.unobserve(e.target);
            }
          });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
        hidden.forEach(function (el) { io.observe(el); });
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* CUSTOM nav-feedback — beim Klick auf einen internen Navigations-Link sofort ein sichtbares
   Highlight (rot) setzen, damit man merkt, dass der Klick ankam und die Seite lädt. Sonst
   fühlt sich die kurze Lade-/View-Transition-Latenz „tot" an. Kein Ladebalken. */
(function () {
  if (window.__navFeedback) return;
  window.__navFeedback = true;
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    if (a.target === '_blank' || a.hasAttribute('download')) return;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#' || href.lastIndexOf('javascript:', 0) === 0 || href.lastIndexOf('mailto:', 0) === 0 || href.lastIndexOf('tel:', 0) === 0) return;
    if (a.origin && a.origin !== window.location.origin) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    a.classList.add('is-navigating');
    // Aus dem Menü heraus: Drawer deckend halten (nicht wegblenden), damit beim Laden
    // NICHT kurz die alte Seite durchblitzt. Der rote Punkt bleibt so auch sichtbar.
    if (a.closest && a.closest('.menu-drawer')) {
      document.documentElement.classList.add('nav-hold-menu');
    }
  }, true);
  // Zurück-Navigation (bfcache): Zustände zurücksetzen.
  window.addEventListener('pageshow', function () {
    document.documentElement.classList.remove('nav-hold-menu');
    var els = document.querySelectorAll('.is-navigating');
    for (var i = 0; i < els.length; i++) els[i].classList.remove('is-navigating');
  });
})();
